import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store, persistor } from './Redux/Store';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import axios from 'axios';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import './assets/css/style.css';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const theme = extendTheme({
  styles: {
    global: {
      // Deshabilitar el reset de algunos elementos
      'html, body': {
        margin: 0,
        padding: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'var(--bg-dark)', // Fondo oscuro
        color: 'var(--text-light)', // Texto claro
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ChakraProvider theme={theme}>
          <App />
          <Analytics />
          <SpeedInsights />
        </ChakraProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

reportWebVitals();
